import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Index("class", ["department"], {})
@Index("subject", ["subject"], {})
@Index("qno", ["qno"], {})
@Index("marks", ["marks"], {})
@Index("idx_cq_bankview", ["department", "subject", "marks", "qno"], {})
@Index("idx_cq_ability", ["department", "subject"], {})
@Entity("createquestion")
export class CreateQuestion {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "department" })
  department: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("varchar", { name: "qno", length: 50, nullable: true })
  qno: string;

  @Column("int", { name: "ref_no", nullable: true })
  refNo: number;

  @Column("varchar", { name: "ref_year", length: 7, nullable: true })
  refYear: string;

  @Column("longtext", { name: "question", nullable: true })
  question: string;

  @Column("int", { name: "language", nullable: true })
  language: number;

  @Column("float", { name: "marks", nullable: true })
  marks: number;

  @Column("int", { name: "complexity", nullable: true })
  complexity: number;

  @Column("int", { name: "questiontype", nullable: true })
  questiontype: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @Column("varchar", { name: "created_by", length: 100, nullable: true })
  createdBy: string;

  @Column("varchar", { name: "updated_by", length: 100, nullable: true })
  updatedBy: string;

  @Column("varchar", { name: "prepared_by", length: 255, nullable: true })
  preparedBy: string;

  @Column("varchar", { name: "mobile_no", length: 20, nullable: true })
  mobileNo: string;

  @Column("longtext", { name: "answer_key", nullable: true })
  answerKey: string;

  @Column("varchar", { name: "source", length: 255, nullable: true })
  source: string;

  @Column("tinyint", { name: "previous_appearance_count", nullable: true, default: 0 })
  previousAppearanceCount: number;

  @Column("varchar", { name: "approved_by", length: 255, nullable: true })
  approvedBy: string;

  @Column("datetime", { name: "approved_date", nullable: true })
  approvedDate: Date;

  @Column("varchar", { name: "approval_status", length: 20, default: "PENDING" })
  approvalStatus: string;

  @CreateDateColumn({ name: "created_at", type: "datetime" })
  createdAt: Date;

  @UpdateDateColumn({ name: "updated_at", type: "datetime" })
  updatedAt: Date;
}
